/* BRICK MAFIA — storefront JS (Shopify port).
   - Cart: uses Shopify /cart/*.js AJAX endpoints, no localStorage
   - Drawer nav + right-side cart drawer
   - Theme toggle (shares bm-store-theme with the password page)
   - Product page swipe gallery + color/size options
   - Newsletter form: falls back to a mailto: bridge until an ESP is wired
*/
(function () {
  'use strict';
  const $  = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => root.querySelectorAll(s);
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  const FREE_SHIP_THRESHOLD_CENTS = 10000;

  /* ===== Theme (shares localStorage key with the password page) ===== */
  const applyTheme = (mode) => {
    if (mode === 'light') document.documentElement.dataset.theme = 'light';
    else delete document.documentElement.dataset.theme;
    try { localStorage.setItem('bm-store-theme', mode); } catch (e) {}
    // Swap the brand logo if a light variant is present in the DOM.
    const dark  = document.documentElement.dataset.logoDark;
    const light = document.documentElement.dataset.logoLight;
    $$('img[data-brand-logo]').forEach(img => {
      if (mode === 'light' && light) img.src = light;
      else if (dark) img.src = dark;
    });
  };
  let savedTheme = 'dark';
  try { savedTheme = localStorage.getItem('bm-store-theme') === 'light' ? 'light' : 'dark'; } catch (e) {}
  applyTheme(savedTheme);

  /* ===== Drawer nav + backdrop ===== */
  const drawer   = $('#drawer');
  const backdrop = $('#backdrop');
  const menuBtn  = $('#menu-btn');
  let drawerFocusReturn = null;
  const openDrawer = () => {
    if (!drawer || !backdrop) return;
    drawerFocusReturn = document.activeElement;
    drawer.removeAttribute('inert');
    document.documentElement.classList.add('nav-open'); document.body.classList.add('nav-open');
    requestAnimationFrame(() => { drawer.classList.add('open'); backdrop.classList.add('on'); });
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
  };
  const closeDrawer = (restore = true) => {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('open'); backdrop.classList.remove('on');
    document.documentElement.classList.remove('nav-open'); document.body.classList.remove('nav-open');
    setTimeout(() => drawer.setAttribute('inert', ''), 380);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    if (restore && drawerFocusReturn) drawerFocusReturn.focus();
  };
  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (backdrop) backdrop.addEventListener('click', () => closeDrawer());
  $$('#drawer .close, #drawer a').forEach(el => el.addEventListener('click', () => closeDrawer(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer(); });

  /* ===== Theme toggles ===== */
  const wireThemeButtons = () => {
    const headerBtn = $('#theme-btn');
    if (headerBtn) headerBtn.addEventListener('click', () => {
      applyTheme(document.documentElement.dataset.theme === 'light' ? 'dark' : 'light');
      syncThemeSegments();
    });
    $$('.theme-row [data-theme-mode]').forEach(b => b.addEventListener('click', () => {
      applyTheme(b.dataset.themeMode);
      syncThemeSegments();
    }));
  };
  const syncThemeSegments = () => {
    const cur = document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
    $$('.theme-row [data-theme-mode]').forEach(b => b.classList.toggle('on', b.dataset.themeMode === cur));
  };
  wireThemeButtons();
  syncThemeSegments();

  /* ===== Cart drawer + Shopify AJAX API ===== */
  const cartDrawer   = $('#bm-cart-drawer');
  const cartBackdrop = $('#bm-cart-backdrop');
  const cartItemsEl  = $('#bm-cart-items');
  const cartSubEl    = $('#bm-cart-sub');
  const cartShipEl   = $('#bm-cart-ship');
  const cartFootEl   = $('#bm-cart-foot');

  // Cart thumbnails for launch products — Shopify's product.featured_image is stale,
  // so we override with the same curated launch photos used on the collection grid +
  // product page gallery, matched by handle + color variant.
  const CDN_FILES = 'https://cdn.shopify.com/s/files/1/0618/2174/7432/files/';
  const launchThumbFor = (it) => {
    const handle = (it.handle || '').toLowerCase();
    const opts = (it.options_with_values || []).reduce((m, o) => { m[(o.name||'').toLowerCase()] = (o.value||'').toLowerCase(); return m; }, {});
    const color = opts.color || opts.colour || '';
    if (handle === 'the-original-donor-hoodie-2') {
      return CDN_FILES + (color === 'white' ? 'bm-h-white-flat-front.jpg' : 'bm-h-black-flat-front.jpg');
    }
    if (handle === 'jf-hat') {
      return CDN_FILES + (color === 'white' ? 'bm-hat-white-flat.jpg' : 'bm-hat-black-flat.jpg');
    }
    return null;
  };

  const renderCart = (cart) => {
    if (!cartItemsEl) return;
    if (!cart.items || !cart.items.length) {
      cartItemsEl.innerHTML = '<div class="bm-cart-empty">Your cart is empty.</div>';
      if (cartFootEl) cartFootEl.style.display = 'none';
    } else {
      if (cartFootEl) cartFootEl.style.display = '';
      cartItemsEl.innerHTML = cart.items.map(it => `
        <div class="bm-cart-item" data-key="${it.key}" data-qty="${it.quantity}">
          <img src="${launchThumbFor(it) || it.image || ''}" alt="">
          <div class="bm-cart-item-info">
            <div class="bm-cart-item-name">${it.product_title}</div>
            <div class="bm-cart-item-meta">${it.variant_title || ''}</div>
            <div class="bm-cart-item-price">${money(it.final_line_price)}</div>
            <div class="bm-cart-qty">
              <button type="button" data-qty-btn="dec" aria-label="Decrease">−</button>
              <span data-qty-display>${it.quantity}</span>
              <button type="button" data-qty-btn="inc" aria-label="Increase">+</button>
              <a class="bm-cart-remove" href="#" data-remove>Remove</a>
            </div>
          </div>
        </div>
      `).join('');
      cartItemsEl.querySelectorAll('.bm-cart-item').forEach(item => {
        const key = item.dataset.key;
        item.querySelector('[data-qty-btn="inc"]').addEventListener('click', () => bumpQty(key, +1));
        item.querySelector('[data-qty-btn="dec"]').addEventListener('click', () => bumpQty(key, -1));
        item.querySelector('[data-remove]').addEventListener('click', (e) => { e.preventDefault(); bumpQty(key, 0, /*absolute*/ true); });
      });
    }
    if (cartSubEl)  cartSubEl.textContent  = money(cart.total_price || 0);
    if (cartShipEl) {
      if ((cart.total_price || 0) >= FREE_SHIP_THRESHOLD_CENTS) {
        cartShipEl.innerHTML = '<span class="free">FREE</span>';
      } else {
        cartShipEl.textContent = 'Calculated at checkout';
      }
    }
    $$('.js-cart-badge').forEach(b => { b.textContent = cart.item_count > 0 ? String(cart.item_count) : ''; });
  };

  // Pending-delta map keeps clicks additive when they land while a POST is in flight:
  // two fast +1 clicks accumulate to +2 in `pending[key]`, and the queued mutation
  // reads that total, then clears it — so no click is silently dropped or double-counted.
  const pending = Object.create(null);
  let mutationChain = Promise.resolve();

  const bumpQty = (key, delta, absolute = false) => {
    if (absolute) {
      // Remove: coalesce to a definite target of 0
      pending[key] = { absolute: 0 };
    } else {
      const cur = pending[key] || { delta: 0 };
      if (cur.absolute !== undefined) return; // already scheduled remove wins
      cur.delta = (cur.delta || 0) + delta;
      pending[key] = cur;
    }
    // Optimistically reflect the click in the visible quantity so the UI feels
    // reactive even before the server responds.
    const row = cartItemsEl && cartItemsEl.querySelector(`.bm-cart-item[data-key="${CSS.escape(key)}"]`);
    if (row) {
      const disp = row.querySelector('[data-qty-display]');
      const baseline = parseInt(row.dataset.qty, 10) || 0;
      const preview = pending[key].absolute !== undefined
        ? pending[key].absolute
        : Math.max(0, baseline + (pending[key].delta || 0));
      if (disp) disp.textContent = String(preview);
    }
    // Serialize the actual POSTs so Shopify never sees interleaved writes.
    mutationChain = mutationChain.then(() => flushPending(key), () => flushPending(key));
    return mutationChain;
  };

  const flushPending = async (key) => {
    const p = pending[key];
    if (!p) return;
    delete pending[key];
    try {
      let targetQty;
      if (p.absolute !== undefined) {
        targetQty = p.absolute;
      } else {
        // Read the server's current quantity so accumulated deltas apply on top of truth.
        const cart = await fetch('/cart.js').then(r => r.json());
        const item = (cart.items || []).find(i => i.key === key);
        if (!item) { renderCart(cart); return; }
        targetQty = Math.max(0, item.quantity + p.delta);
      }
      const r = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: targetQty })
      });
      const c = await r.json();
      renderCart(c);
    } catch (e) {
      // Failure — re-sync from the server so the UI matches truth
      try { renderCart(await fetch('/cart.js').then(r => r.json())); } catch (_) {}
    }
  };

  const fetchCart = async () => {
    try { const r = await fetch('/cart.js'); const c = await r.json(); renderCart(c); return c; }
    catch (e) { return { items: [], item_count: 0 }; }
  };

  const openCart = () => {
    if (!cartDrawer || !cartBackdrop) return;
    cartBackdrop.classList.add('on');
    requestAnimationFrame(() => cartDrawer.classList.add('open'));
    document.documentElement.classList.add('nav-open'); document.body.classList.add('nav-open');
    fetchCart();
  };
  const closeCart = () => {
    if (!cartDrawer || !cartBackdrop) return;
    cartDrawer.classList.remove('open'); cartBackdrop.classList.remove('on');
    document.documentElement.classList.remove('nav-open'); document.body.classList.remove('nav-open');
  };
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  const cartCloseBtn = $('#bm-cart-close');
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);
  const cartCheckoutBtn = $('#bm-cart-checkout');
  if (cartCheckoutBtn) cartCheckoutBtn.addEventListener('click', () => { window.location.href = '/checkout'; });
  const cartContinueBtn = $('#bm-cart-continue');
  if (cartContinueBtn) cartContinueBtn.addEventListener('click', closeCart);

  // Add-to-cart handler: any form with data-bm-atc submits via Shopify's AJAX endpoint.
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-bm-atc]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!r.ok) throw new Error(await r.text());
      await fetchCart();
      openCart();
    } catch (err) {
      alert('Could not add to cart. ' + (err.message || err));
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  });

  fetchCart();

  /* ===== Newsletter form — mailto bridge until ESP is wired ===== */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-bm-newsletter]');
    if (!form) return;
    e.preventDefault();
    const email = (new FormData(form).get('contact[email]') || new FormData(form).get('email') || '').toString().trim().toLowerCase();
    if (!email.includes('@')) return;
    form.closest('.bm-signup').classList.add('thanks');
    const subject = encodeURIComponent('Newsletter signup — ' + email);
    const body = encodeURIComponent(`Please add me to the BRICK MAFIA drop-alert list.\n\nEmail: ${email}\n\n(Sent from brickmafiaofficial.com)`);
    const f = document.createElement('iframe');
    f.style.display = 'none';
    f.src = `mailto:support@brickmafiaofficial.com?subject=${subject}&body=${body}`;
    document.body.appendChild(f);
    setTimeout(() => f.remove(), 3000);
  });

  /* ===== Announcement bar close ===== */
  $$('[data-ann-close]').forEach(btn => btn.addEventListener('click', () => {
    const bar = btn.closest('.bm-ann');
    if (bar) { bar.remove(); try { sessionStorage.setItem('bm-ann-closed', '1'); } catch (e) {} }
  }));

  /* ===== Product page swipe gallery + variants ===== */
  const track   = $('#gallery-track');
  const dotsEl  = $('#gallery-dots');
  const prevBtn = $('#gallery-prev');
  const nextBtn = $('#gallery-next');
  if (track) {
    const slides = $$('.gallery-slide', track);
    let active = 0;
    let debounce;
    const setActive = (i, smooth = true) => {
      active = Math.max(0, Math.min(i, slides.length - 1));
      const prev = track.style.scrollBehavior;
      track.style.scrollBehavior = smooth ? 'smooth' : 'auto';
      track.scrollLeft = active * track.clientWidth;
      track.style.scrollBehavior = prev || '';
      if (dotsEl) $$('button', dotsEl).forEach((b, bi) => b.classList.toggle('on', bi === active));
      // If the slide has a color hint, sync the swatch (keeps cart matching viewer).
      const slideColor = slides[active] && slides[active].dataset.color;
      if (slideColor) syncColorSwatch(slideColor);
    };
    track.addEventListener('scroll', () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (i !== active) setActive(i);
      }, 90);
    });
    if (prevBtn) prevBtn.addEventListener('click', () => setActive(active - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => setActive(active + 1));
    if (dotsEl) $$('button', dotsEl).forEach((b, i) => b.addEventListener('click', () => setActive(i)));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); setActive(active - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); setActive(active + 1); }
    });
    // Sync initial position without any smooth-scroll flash.
    requestAnimationFrame(() => { track.style.scrollBehavior = 'auto'; track.scrollLeft = 0; });
    window.bmGoToColor = (colorName) => {
      const idx = [...slides].findIndex(s => (s.dataset.color || '').toLowerCase() === (colorName || '').toLowerCase());
      if (idx >= 0) setActive(idx);
    };
  }

  const syncColorSwatch = (colorName) => {
    const pickedEl = $('#color-picked');
    let picked = null;
    $$('.swatch').forEach(sw => {
      const on = (sw.dataset.color || '').toLowerCase() === (colorName || '').toLowerCase();
      sw.classList.toggle('on', on);
      if (on) picked = sw;
    });
    if (pickedEl && picked) pickedEl.textContent = picked.dataset.color;
    // Rebuild variant id on any color/size change
    updateSelectedVariant();
  };

  /* Variant selection */
  const variantData = (() => { try { return JSON.parse($('#bm-variants')?.textContent || '[]'); } catch (e) { return []; } })();
  const findVariant = (color, size) => {
    if (!variantData.length) return null;
    const colorLc = (color || '').toLowerCase();
    const sizeLc  = (size || '').toLowerCase();
    return variantData.find(v => {
      const opts = (v.options || []).map(o => (o || '').toLowerCase());
      if (!opts.includes(colorLc)) return false;
      if (opts.length < 2) return true;
      return opts.includes(sizeLc);
    }) || variantData[0];
  };
  const getSelectedColor = () => ($('.swatch.on')?.dataset.color) || (variantData[0]?.options?.[0]);
  const getSelectedSize  = () => ($('.size-btn.on')?.textContent.trim()) || (variantData[0]?.options?.[1] || 'One Size');
  const updateSelectedVariant = () => {
    const v = findVariant(getSelectedColor(), getSelectedSize());
    if (!v) return;
    $$('input[name="id"]').forEach(inp => { inp.value = v.id; });
    const priceEl = $('#p-price'); if (priceEl && v.price) priceEl.textContent = money(v.price);
    const ctaAdd = $('#cta-add'); if (ctaAdd) ctaAdd.textContent = 'Add to Cart · ' + money(v.price || 0);
    const stickyAdd = $('#sticky-add'); if (stickyAdd) stickyAdd.textContent = 'Add to Cart · ' + money(v.price || 0);
    const availableEl = $('[data-avail]'); if (availableEl) availableEl.textContent = v.available ? '' : 'Sold out';
  };
  $$('.swatch').forEach(sw => sw.addEventListener('click', () => {
    syncColorSwatch(sw.dataset.color);
    if (window.bmGoToColor) window.bmGoToColor(sw.dataset.color);
  }));
  $$('.size-btn').forEach(sb => sb.addEventListener('click', () => {
    $$('.size-btn').forEach(x => x.classList.remove('on'));
    sb.classList.add('on');
    const pick = $('#size-picked'); if (pick) pick.textContent = sb.textContent.trim();
    updateSelectedVariant();
  }));
  updateSelectedVariant();
})();
